var _rect, _path, _circle, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 504",
    width: 720,
    height: 504,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 504,
    fill: "#009c3b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 60 660 252 360 444 60 252Z",
    fill: "#ffdf00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 252,
    r: 126,
    fill: "#002776"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "brGlobe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 252,
    r: 126
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brGlobe)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 206,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 188,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 214,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294,
    cy: 240,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 230,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 250,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 230,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 212,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 276,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 250 C312 308 408 308 488 250 L488 272 C408 330 312 330 232 272 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/br.fbfed1f80494ec8d665fd52c6ea640e5.svg";
export { ForwardRef as ReactComponent };